
export const PageDirectory = {
    SHOWCASE: "", // currently there is no showcase yet (28 Aug)
    ARTICLES: 'articles',
    OUR_PURPOSE: "purpose",
    CONTACT_US: "reach-out-to-us",
}